import { Icon } from "@iconify/react";
import { forwardRef } from "react";

const Iconify = forwardRef(
  (
    { icon, width = 20, style, className = "", altText = "", ...other },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={`component-iconify ${className}`}
        style={{
          width,
          height: width,
          display: "flex",
          alignItems: "center",
          ...style,
        }}
        {...other}
      >
        {icon ? (
          <Icon icon={icon} width={width} height={width} />
        ) : (
          <div
            style={{
              width,
              height: width,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {altText}
          </div>
        )}
      </div>
    );
  }
);

export default Iconify;
